<template>
	 <el-button @click="send">默认按钮</el-button>
</template>

<script>
	export default{
		name:'Mail',
		data(){
			return{
				
			}
		},
		methods:{
			send(){
				this.httpPost({
					url:'/admin/mail/mail',
				}).then((res)=>{
					if(res.code ==1){
						alert('success');
					}
				})
			}
		},
		created() {
			
		}
	}
</script>

<style>
</style>
